module.exports = __webpack_public_path__ + "static/media/stockspot.863065f9.png";